import {ProfileAffinityGroup} from 'model/profileAffinityGroup';

export const AffinityGroup = ProfileAffinityGroup;
